module.exports = __webpack_public_path__ + "static/media/aye_pyae.1c89bb8e.png";